const MARKER = 'ftBrowserSession';

/** Cookie de sessão (sem Max-Age/Expires) — o navegador apaga ao fechar. */
export function setBrowserSessionMarker(): void {
  document.cookie = `${MARKER}=1; path=/; SameSite=Lax`;
}

export function hasBrowserSessionMarker(): boolean {
  return document.cookie.split(';').some(c => c.trim().startsWith(`${MARKER}=`));
}

export function clearBrowserSessionMarker(): void {
  document.cookie = `${MARKER}=; path=/; Max-Age=0; SameSite=Lax`;
}

/** Chaves de auth/sessão espelhadas em localStorage p/ persistir entre abas. */
export const AUTH_STORAGE_KEYS = [
  'token', 'idToken', 'refreshToken', 'userID', 'nameUser', 'sessionId', 'language', '_ui_role', '_ui_pref_t',
];

/**
 * Roda o MAIS CEDO possível (main.ts, antes do Angular subir):
 * - Sem marcador (navegador foi fechado desde a última vez) → descarta a auth persistida
 *   (força re-login na próxima abertura do navegador).
 * - Com marcador (mesma sessão do navegador, ex.: aba nova) → hidrata o sessionStorage a
 *   partir do localStorage. Assim nenhum serviço/guard lê um sessionStorage vazio numa aba nova.
 */
export function hydrateSessionOnStartup(): void {
  try {
    if (!hasBrowserSessionMarker()) {
      AUTH_STORAGE_KEYS.forEach(k => localStorage.removeItem(k));
      setBrowserSessionMarker();
      return;
    }
    AUTH_STORAGE_KEYS.forEach(k => {
      const v = localStorage.getItem(k);
      if (v !== null && sessionStorage.getItem(k) === null) sessionStorage.setItem(k, v);
    });
    setBrowserSessionMarker();
  } catch { /* storage indisponível — ignora */ }
}

/** Espelha sessionStorage → localStorage (chamado após login/refresh). */
export function persistSessionToLocalStorage(): void {
  setBrowserSessionMarker();
  AUTH_STORAGE_KEYS.forEach(k => {
    const v = sessionStorage.getItem(k);
    if (v !== null) localStorage.setItem(k, v); else localStorage.removeItem(k);
  });
}

/** Limpa a auth persistida (chamado no logout). */
export function clearPersistedSession(): void {
  AUTH_STORAGE_KEYS.forEach(k => localStorage.removeItem(k));
  localStorage.removeItem('postLoginRedirect');
}

/**
 * Self-heal: recopia as chaves de auth do localStorage (fonte durável) → sessionStorage,
 * para chaves que estejam faltando no sessionStorage. Usado defensivamente antes de
 * requisições autenticadas — cobre o caso de o sessionStorage ter sido esvaziado por
 * algum fluxo/ambiente enquanto a sessão ainda é válida no localStorage. Não mexe no marcador.
 */
export function rehydrateSessionKeys(): void {
  try {
    AUTH_STORAGE_KEYS.forEach(k => {
      const v = localStorage.getItem(k);
      if (v !== null && sessionStorage.getItem(k) === null) sessionStorage.setItem(k, v);
    });
  } catch { /* storage indisponível — ignora */ }
}
